import axios from 'utils/axios';
import { apiEndpoint } from 'config/api.config';

export interface UserDto {
  id: string;
  firstName: string;
  lastName: string;
}

const userNameCache: Record<string, string> = {};

const userRepository = {
  getUser: async (id: string, params = {}): Promise<UserDto> => {
    try {
      const { url, config } = apiEndpoint('userProfile', { id: id });
      const response = await axios.get(url, { params, ...config });
      return response.data;
    } catch (error) {
      console.error('Error retrieving User from User Service', error);
      throw error;
    }
  },
  getUserName: async (id: string): Promise<string> => {
    var userName = userNameCache[id];
    if (!userName) {
      try {
        const user = await userRepository.getUser(id);
        userName = `${user.firstName} ${user.lastName}`;
      } catch {
        userName = 'Unknown user';
      }
      userNameCache[id] = userName;
    }
    return userName;
  }
};

export default userRepository;
